const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the google calendar component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('meetsCreate', ['Authorization', 'Meets', function (Authorization, Meets) {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: require('../../templates/directives/meets-create.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;


      self.addMeets = function() {
        Meets.meetsPermissionLink({}).$promise
        .then(function(data) {
          if (data && data.redirect_url) {
            // Application.storage.put('gcal_redirect', {path: Application.navigation.getPath(), query: Application.navigation.getUrlParameters()});
            window.location.href = data.redirect_url;
          } else {
            console.log('missing data from request: ', data);
          }
        }).catch(error => {
          console.log('error in meets create: ', error);
        });
      };

    }],
    controllerAs: 'meetsCreate'
  };
}]);